<div class="common-modal__container">
  <div class="common-modal__header">
    <span
      class="common-modal__text-header"
      [afTranslate]="'new-report.new-report'">
      _Nuevo informe
    </span>
  </div>
  <div class="common-modal__content">
    <div class="common-modal__form-container">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">
          *
        </span>
        <span
          [afTranslate]="'common.required-fields'"
          class="common-tag__mandatory-label-text-obligatory-message">
          _Campos obligatorios
        </span>
      </div>
      @if (skin !== 'icam-red') {
        <field-type-list-simple
          [field]="newReport.associatedClient"
          [preSelectItem]="newReport.report.associatedClient"
          [listValues]="newReport.clientListModify"
          (itemSelected)="itemSelected($event, 'client')">
        </field-type-list-simple>
        <field-type-list-simple
          [field]="newReport.associatedImplantation"
          [preSelectItem]="newReport.report.associatedImplantation"
          [listValues]="newReport.evaluationListModify"
          (itemSelected)="itemSelected($event, 'evaluation')">
        </field-type-list-simple>
      }
      <field-type-list-simple
        [field]="newReport.typeReport"
        [preSelectItem]="newReport.report.typeReport"
        [listValues]="newReport.typeReportList"
        (itemSelected)="itemSelected($event, 'typeReport')">
      </field-type-list-simple>
      <field-type-text-simple
        [field]="newReport.nameReport"
        [preSelectItem]="newReport.report.name"
        (itemSelected)="itemSelected($event, 'name')">
      </field-type-text-simple>
    </div>
  </div>
  <div class="common-modal__footer">
    <button
      (click)="handleDismiss()"
      class="common-button__text-border">
      <span
        [afTranslate]="'common.cancel'"
        class="common-button__text-title">
        _Cancelar
      </span>
    </button>
    <button
      (click)="generateReport()"
      class="common-button__text">
      <span
        [afTranslate]="'common.generate'"
        class="common-button__text-title">
        _Generar
      </span>
    </button>
  </div>
</div>
